<div class="d-flex flex-column align-items-center" id="mentions-legales">
  <h1 class="mt-3 mb-3">Mentions légales Perval.fr</h1>
  <hr class="bg-primary py-1 px-5 mb-5 rounded-3 opacity-100 border-primary" />
  <div class="card p-3 rounded-3 mt-3 mb-3">
    <h2 class="fw-bold fs-3 text-secondary">
      1. INFORMATIONS ÉDITEUR ET HÉBERGEUR
    </h2>

    <p>Editeur &amp; hébergeur : ADNOV,</p>
    <p>
      SASU au capital de 2 421 820 euros dont le siège social est situé 95
      avenue des Logissons - 13107 Venelles cedex ; RCS Aix-en-Provence 381 000
      611
    </p>
    <p>Contact : N°Tel . 0 800 710 620</p>
    <p>Président d’ADNOV : Me Antoine DEJOIE</p>
    <p>
      Le Site est hébergé par ADNOV sur les infrastructures d’AWS (Amazon web
      services EMEA SARL, succursale française, immatriculée au RCS de Nanterre,
      sous le numéro 831 001 334, TVA FR30831001334,
      <a href="https://aws.amazon.com/fr/contact-us"
        >https://aws.amazon.com/fr/contact-us</a
      >).
    </p>
    <p>
      Vous pouvez contacter ADNOV pour toute information relative à
      l’hébergement du Site ou demande de suppression de contenus.
    </p>
    <p>
      La publication porte sur les informations générales relatives au droit et
      à la profession notariale.
    </p>
  </div>
  <div class="card p-3 rounded-3 mt-3 mb-3">
    <h2 class="fw-bold fs-3 text-secondary">
      2. PROPRIÉTÉ INTELLECTUELLE ET DROIT D’UTILISATION
    </h2>
    <h3 class="fw-bold fs-4 text-secondary">
      2.1. Contenu mis en ligne par l’Editeur (droit d’auteur)
    </h3>

    <p>L’Editeur est propriétaire de ce site Web.</p>
    <p>
      Tout le contenu réalisé ou mis à disposition sur ce site, y compris, mais
      non exclusivement, les textes, les graphiques, les photographies, les
      illustrations et les logiciels est la propriété de l’Editeur, des
      bénéficiaires de licence et des fournisseurs de contenu.
    </p>
    <p>
      Sauf disposition expresse de la présente publication concernant un
      fichier, un document ou un extrait précis, l’Editeur concède, par la
      présente, le droit de visualiser, mémoriser et reproduire des exemplaires
      de cette publication pour vos besoins personnels.
    </p>
    <p>
      L’Utilisateur accepte, pour autant, de se conformer aux lois françaises
      sur les données nominatives, sur la protection industrielle, les droits
      d'auteurs, la presse et la communication, ainsi qu'aux traités et accords
      internationaux relatifs à ce domaine et aux domaines connexes.
    </p>
    <p>En conséquence, l’Utilisateur s’interdit de :</p>
    <ul>
      <li>
        Reproduire intégralement ou partiellement pour vendre, distribuer,
        émettre, publier et communiquer sous quelque forme que ce soit, les
        données ou œuvres protégées par le droit d'auteur attaché à l'œuvre ou à
        la donnée reproduite sans autorisation écrite particulière et préalable
        du détenteur des droits d'auteur attachés à l'œuvre ou à la donnée
        reproduite ;
      </li>
      <li>
        Réutiliser toute information dans un but commercial ou publicitaire ;
      </li>
      <li>
        Introduire des données sur ce site qui modifieraient ou seraient
        susceptibles de modifier le contenu ou l'apparence des données ou œuvres
        figurant sur ce site.
      </li>
    </ul>
    <p>
      Les mentions du droit d’auteur (copyright) devront être visibles sur
      chaque exemplaire de la publication que cette dernière soit utilisée en
      tout ou partie.
    </p>
    <p>
      Tous les droits attachés aux copyrights restent la propriété du titulaire.
    </p>
    <p>
      Les marques de l'Editeur ainsi que les logos figurant sur le site sont
      protégés.
    </p>
    <p>
      Toute reproduction ou représentation totale ou partielle de ces marques ou
      de ces logos, seules ou intégrées à d'autres éléments sans l'autorisation
      expresse et préalable de l'Editeur est prohibée et engagerait la
      responsabilité de l'utilisateur au sens des articles L 713-2 et L 713-3 du
      Code de la Propriété Intellectuelle.
    </p>
    <h3 class="fw-bold fs-4 text-secondary">
      2.2. Contenu mis en ligne par le directeur de la publication
    </h3>

    <p>
      Le directeur de la publication est propriétaire du contenu de ce site Web
      qu’il a mis en ligne, à l’exclusion de tout autre contenu mis en ligne par
      l’Editeur.
    </p>
  </div>
  <div class="card p-3 rounded-3 mt-3 mb-3">
    <h2 class="fw-bold fs-3 text-secondary">
      3. PORTÉE DES CONTENUS GARANTIES ET RESPONSABILITÉS
    </h2>

    <p>
      L’Editeur ne donne aucune garantie, explicite ou implicite, et n'assume
      aucune responsabilité relative à l'utilisation du Site.
    </p>
    <p>
      Les informations contenues sur le Site engagent seule la responsabilité de
      leur auteur et ne sauraient engager la responsabilité de l’Editeur lorsque
      ce dernier n’est pas l’auteur de ces informations.
    </p>
    <p>
      L’Editeur ne donne pas de garantie quant à la qualité, l'exactitude,
      l'actualité, l'ordre ou l'exhaustivité de l'information ou des documents
      dans ce site, et n'est tenu à aucune mise à jour de ces informations.
    </p>
    <p>
      En aucun cas L’Editeur, ou un tiers impliqué dans la création de ce Site
      ne sont responsables, ni ne peuvent être redevables à un utilisateur ou
      une autre partie, des dommages directs ou indirects, spéciaux,
      particuliers ou accessoires découlant de l'utilisation de ce Site ou d'un
      autre site relié par un lien hypertexte, notamment des pertes de profit,
      de l'interruption des affaires, des pertes de programmes ou d'autres
      données du système de gestion de l'information de l'utilisateur ou autre,
      même si L’Editeur est expressément informé que des dommages sont
      possibles.
    </p>
    <p>
      La connexion de l’Utilisateur à tout autre site extérieur est à ses
      risques exclusifs.
    </p>
  </div>
  <div class="card p-3 rounded-3 mt-3 mb-3">
    <h2 class="fw-bold fs-3 text-secondary">4. LIENS HYPERTEXTE</h2>

    <p>
      La mise en place de liens hypertexte pointant vers le contenu du Site est
      interdite, sauf autorisation préalable et expresse de l’Editeur qui peut
      autoriser la mise en place d’un lien hypertexte pointant vers son contenu,
      sous réserves spécifiques.
    </p>
    <p>Dans ce dernier cas, il est nécessaire de :</p>
    <ul>
      <li>
        ne pas utiliser la technique du lien profond ("deep linking"),
        c'est-à-dire que les pages du Site ne doivent pas être imbriquées à
        l'intérieur des pages d'un autre site, mais accessible par l’ouverture
        d’une fenêtre,
      </li>
      <li>
        mentionner la source qui pointera grâce à un lien hypertexte directement
        sur le contenu visé.
      </li>
    </ul>
    <p>
      Les informations utilisées ne doivent l'être que dans le cadre de
      l’exercice de la profession notariale. Toute utilisation à des fins
      commerciales ou publicitaires est exclue.
    </p>
    <p>
      L’Editeur décline toute responsabilité en ce qui concerne l’accès, le
      contenu ou l’utilisation de ces sites et notamment les pratiques et les
      politiques de protection de la confidentialité des données des sites
      auxquels le Site pourrait être relié par des liens hypertextes, et vous
      invite à en prendre connaissance.
    </p>
  </div>

  <div class="card p-3 rounded-3 mt-3 mb-3">
    <h2 class="fw-bold fs-3 text-secondary">
      5. DONNÉES DE CONNEXION ET UTILISATION D’OUTILS DE TRAÇAGE
    </h2>
    <p>
      Les données de connexion au site (fichiers log) sont utilisées uniquement
      pour la sécurité du site (détection d'éventuelles intrusions) et pour
      estimer la fréquentation générale du site (exemple : les rubriques les
      plus consultées). Ces données de connexion sont conservées conformément à
      la législation applicable pour permettre à l’Editeur d'établir des
      statistiques annuelles de fréquentation avant d’être détruites.
    </p>
    <p>
      Lors de l’ouverture et de la navigation sur notre site internet, un outil
      de traçage génère et dépose un ou plusieurs cookie(s) sur le terminal de
      l’Utilisateur. Un cookie est un fichier texte qui collecte des
      informations notamment l’identifiant du terminal de l’Utilisateur.
    </p>
    <p>Différents types de cookies sont utilisés :</p>
    <h3 class="fw-bold fs-4 text-secondary">
      5.1. Les cookies non persistants
    </h3>

    <p>
      La collecte de données a pour unique objectif d’assurer le bon
      fonctionnement du site et de ses services. Les cookies générés sont
      temporaires. Certains peuvent persister sur votre terminal jusqu’à
      quelques heures après la fermeture du navigateur.
    </p>
    <ul>
      <li>
        Cookie de navigation facilitant l’ouverture et la navigation sur notre
        site,
      </li>
      <li>
        Cookie de session pour vous fournir certaines fonctionnalités que vous
        avez demandées, tels que l’accès à des pages restreintes.
      </li>
    </ul>
    <h3 class="fw-bold fs-4 text-secondary">5.2. Les cookies persistants</h3>

    <p>
      <strong class="fw-bold">Cookies de mesure d’audience : </strong>le Site
      Perval.fr utilise Google Analytics, un service d'analyse de site internet
      fourni par Google Inc. (« Google »).
    </p>
    <p>
      Afin de mesurer l’audience de la page d’accueil, et de comprendre comment
      les visiteurs utilisent notre site de façon à l’améliorer, Google
      Analytics collecte des données statistiques de fréquentation du site
      (adresse IP, pages visitées, temps passé sur le site, etc) qui sont
      restituées de manière agrégée dans une interface web mis à disposition
      d’ADNOV. A cette fin, Google Analytics génère et dépose un ou plusieurs
      cookie(s) sur votre terminal.
    </p>
    <p>
      Les cookies générés persistent sur le terminal après la fin de la session
      de navigation. Ils permettent de reconnaître le terminal lorsqu’il est
      utilisé pour accéder de nouveau à notre site.
    </p>
    <p>
      Les données générées par les cookies concernant votre utilisation du site
      (y compris votre adresse IP) seront transmises et stockées par Google sur
      des serveurs situés aux Etats-Unis.
    </p>
    <p>
      Nous vous invitons à consulter les règles de confidentialité de Google qui
      ont trait, notamment, aux modalités de collecte des données et à leur
      utilisation via le lien suivant
      <a target="_blank" href="https://www.google.fr/policies/privacy"
        >https://www.google.fr/policies/privacy</a
      >
      ou toute autre URL que Google peut fournir le cas échéant.
    </p>
    <p>
      <strong class="fw-bold">Gérer les Cookies : </strong> vous pouvez
      désactiver certains Cookies, mais pas tous, dans les préférences de votre
      navigateur ou de votre appareil mobile ; cela peut cependant nuire à votre
      utilisation du Site. La méthode de désactivation des Cookies peut varier
      en fonction de l’appareil et du navigateur, mais elle se trouve
      habituellement dans les rubriques Préférences ou Paramètres de sécurité.
    </p>
  </div>
  <div class="card p-3 rounded-3 mt-3 mb-3">
    <h2 class="fw-bold fs-3 text-secondary">6. CRÉDITS PHOTOS</h2>
    <h3 class="fw-bold fs-4 text-secondary">
      Par le directeur de publication:
    </h3>

    <p>
      Le directeur de publication s’engage à garantir que les photographies
      et/ou vidéos ajoutées sont libres de droit ou dans le cas contraire à
      mentionner le nom de l’auteur du document
    </p>
    <h3 class="fw-bold fs-4 text-secondary">Droits gérés :</h3>

    <p>
      Le Site Perval.fr utilise Google Street View, ainsi nous vous invitons à
      consulter les règles de confidentialité de Google qui ont trait,
      notamment, aux modalités de collecte des données et à leur utilisation via
      le lien suivant
      <a target="_blank" href="https://www.google.fr/policies/privacy"
        >https://www.google.fr/policies/privacy</a
      >
      ou toute autre URL que Google peut fournir le cas échéant. (ex :
      <a
        target="_blank"
        href="https://www.google.fr/intl/fr/maps/streetview/understand"
        >https://www.google.fr/intl/fr/maps/streetview/understand</a
      >).
    </p>
    <p>Libres de droits : © Fotolia.</p>
  </div>
  <div class="card p-3 rounded-3 mt-3 mb-3">
    <h2 class="fw-bold fs-3 text-secondary">
      7. MODIFICATIONS DES TERMES ET CONDITIONS
    </h2>

    <p>
      L’Editeur peut à tout moment modifier les présentes en actualisant ce
      site. Ces modifications vous engagent et nous vous recommandons de
      consulter régulièrement ce site pour prendre connaissance des termes et
      conditions en vigueur.
    </p>
  </div>
  <div class="card p-3 rounded-3 mt-3 mb-3">
    <h2 class="fw-bold fs-3 text-secondary">8. INQUIÉTUDES</h2>

    <p>
      Si vous pensez que l’Editeur n'a pas respecté les points qui précèdent,
      nous vous remercions de nous le faire savoir en adressant un courrier à
      l'adresse suivante : ADNOV, 95 Avenue des Logissons, 13107 Venelles Cedex.
      Nous nous chargerons alors d'identifier et de corriger le problème.
    </p>
  </div>
</div>
